import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { isReportId, type ReportId } from "@/features/today"
import { webappRoute } from "./layout"

interface ReportViewSearch {
  /** Which report to show, by its stable id (e.g. `love-match`). */
  report?: ReportId
}

const LazyReportViewPage = lazyRouteComponent(() => import("./lazy-pages"), "ReportViewPage")

export const reportViewRoute = createRoute({
  getParentRoute: () => webappRoute,
  path: "/reports/view",
  validateSearch: (raw: Record<string, unknown>): ReportViewSearch => ({
    report: isReportId(raw.report) ? raw.report : undefined,
  }),
  component: ReportViewComponent,
})

function ReportViewComponent() {
  const { report } = reportViewRoute.useSearch()
  return <LazyReportViewPage reportId={report} />
}
